<template>
            <div class="pos class-1" id="pos"> 
              
                <PosAppHeader /> 
    <body class="pos class-1" id="takeaway">
            <!-- header -->
            <!-- main box -->
            <div class="main_box">
                <div class="left_panel">
                    <div class="cards-container d-flex flex-row flex-wrap ">
                        <div class="delivery-cards p-2" v-for="order in deliveryOrders" :key="order.id">
                            <!-- Scrollable content within each card -->
                            <div class="card-scrollable-content" @click="navigateToPos(order.id)">
                                <div class="symbol"></div>
                                <div class="order-no">
                                    <span class="light">Order #: </span>
                                    <span class="order-id heavy">{{ order.id }}</span>
                                </div>
                                <div class="customer d-flex flex-column align-items-center mt-2">
                                    <span class="light">Area: </span>
                                    <span class="customer-name heavy">{{ order.area }}</span>
                                </div>
                                <div class="amount mt-2">
                                    <span class="light">Amount: </span>
                                    <span class="amount-value heavy">{{ order.totalPay }} AED</span>
                                </div>
                                <div class="driver d-flex flex-column align-items-center mt-2">
                                    <span class="light">Address: </span>
                                    <span class="customer-name heavy">{{ order.build }}, Floor {{ order.floor }}, Flat {{ order.flat }}</span>
                                </div>
                                <!-- <div class="opencard mt-1">
                                    <span>OPEN</span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            
        </body>
    </div> 
</template>

<script>
export default {
    data() {
        return {
            deliveryOrders: []
        }
    },
    mounted() {
        this.fetchDeliveryOrders();
    },
    methods: {
        navigateToPos(orderId) {
             if (!this.$hasPermission('edit orders')){
        this.$toast.error('Not Permitted');
        return;
    }
      this.$router.push({ name: "PosComponent" , params: { orderId: orderId}});
    },
        async fetchDeliveryOrders() {
            try {
                this.$root.isLoading = true; 
          this.loading = true;
                const token = localStorage.getItem('authToken'); 

                const response = await fetch(`${this.$BASE_API_URL}/api/orders/types?types=1`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });
                const data = await response.json();
                if (data.status) {
                    this.deliveryOrders = data.data;
                }
            } catch (error) {
                console.error('Error fetching delivery orders:', error);
            }
            finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
        }
    }
}
</script>


<style scoped>
.delivery-cards {
    width: 250px; 
    height: 300px; 
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin: 10px;
    overflow: hidden; 
    display: flex;
    flex-direction: column;
}

.card-scrollable-content {
    flex: 1;
    overflow-y: auto;
    padding: 12px;
    display: flex;
    flex-direction: column;
    min-height: 100%;
    justify-content: space-around;
    overflow-x: hidden;
}

.card-scrollable-content::-webkit-scrollbar {
    width: 6px;
}

.card-scrollable-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.card-scrollable-content::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

.card-scrollable-content::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.order-no, .customer, .amount, .driver {
    width: 100%;
    text-align: center;
}

.opencard {
    background: #4CAF50;
    color: white;
    padding: 6px 12px;
    border-radius: 4px;
    font-weight: bold;
    margin-top: 8px;
    text-align: center;
}

.heavy {
    font-weight: 600;
}

.cards-container {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
}
.order-no, 
.customer, 
.amount {
    position: relative;
    padding-bottom: 12px;
    margin-bottom: 8px;
}

.order-no::after,
.customer::after,
.amount::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 10%;
    right: 10%;
    height: 1px;
    background-color: #e0e0e0; /* Light gray divider */
}

/* Optional: Add some spacing adjustments */
.customer, .amount, .driver {
    margin-top: 12px;
}

/* Keep your existing styles */
.delivery-cards {
    width: 250px; 
    height: 300px; 
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin: 10px;
    overflow: hidden; 
    display: flex;
    flex-direction: column;
}

.card-scrollable-content {
    flex: 1;
    overflow-y: auto;
    padding: 12px;
    display: flex;
    flex-direction: column;
    min-height: 100%;
    justify-content: space-around;
    overflow-x: hidden;
}
</style>
